<template>
  <div class="hall" @click="onClick">
    <img :src="image" alt="">
  </div>
</template>

<script>
  export default {
    data() {
      return {
        image: "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/cac/hall.png?_t=" + Date.now()
      }
    },
    methods: {
      onClick() {
        this.$router.push({
          path: '/cac/site'
        })
      }
    },
  }
</script>

<style lang="scss" scoped>
  .hall {
    width: 100%;
    img {
      width: 100%;
      display: inline-block;
    }
  }
</style>